import React from 'react';

const SvgLogoTek = (props: any) => (
    <svg viewBox="0 0 60 60" version="1.1" {...props}>
        <circle cx="30" cy="30" fill="#21B4C7" r="30" />
        <g fill="#ffffff">
            <path d="M 30 29.4633 C 31.6 29.4633 32.9 28.0633 32.9 26.2633 L 32.9 8.36332 C 32.9 6.66332 31.6 5.16332 30 5.16332 C 28.4 5.16332 27.1 6.56332 27.1 8.36332 L 27.1 26.2633 C 27.1 28.0633 28.4 29.4633 30 29.4633 Z" />
            <path d="M 38.9 15.3633 C 37.7 16.6633 37.8 18.6633 39 19.9633 C 41.5 22.4633 42.9 25.8633 42.9 29.4633 C 42.9 36.8633 37.1 42.7633 30 42.7633 C 22.9 42.7633 17.1 36.8633 17.1 29.4633 C 17.1 25.8633 18.5 22.4633 21 19.9633 C 22.3 18.6633 22.3 16.6633 21.1 15.3633 C 19.9 14.0633 17.9 14.0633 16.6 15.3633 C 12.9 19.0633 10.8 24.0633 10.8 29.4633 C 10.8 40.3633 19.4 49.1633 30 49.1633 C 40.5 49.1633 49.2 40.3633 49.2 29.4633 C 49.2 24.0633 47.1 19.0633 43.3 15.3633 C 42.1 14.0633 40.1 14.0633 38.9 15.3633 Z" />
        </g>
    </svg>
);

export default SvgLogoTek;
